<textarea class="form-control" [(ngModel)]="text" [rows]="rows" [placeholder]="placeholder"></textarea>
<p class="help-block">{{ stateFeedback }}
	<span [hidden]="!working">
		<i class="fa fa-spin ion-load-c"></i>
	</span>
</p>
